import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/[0.08] bg-[#0A0A0B]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <Logo testid="footer-logo" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-neutral-500">
            vyne verbindet deinen Kleiderschrank, Lieblingsmarken und einen KI-Stylist zu einem Ort für deinen Stil.
          </p>
        </div>
        <div className="flex flex-col gap-2 text-sm text-neutral-400">
          <span className="label-over mb-2">Entdecken</span>
          <Link to="/katalog" className="hover:text-white">Partner-Marken</Link>
          <Link to="/marktplatz" className="hover:text-white">Marktplatz</Link>
          <Link to="/stylist" className="hover:text-white">KI-Stylist</Link>
        </div>
        <div className="text-xs leading-relaxed text-neutral-500" data-testid="affiliate-disclosure">
          <span className="label-over mb-3 block">Transparenz</span>
          Links zu Partner-Shops sind Affiliate-Links. Kaufst du darüber, erhält vyne eine Provision – für dich ändert sich der Preis nicht.
          Bei Marktplatz-Verkäufen behält vyne eine Provision vom Verkaufspreis ein.
        </div>
      </div>
      <div className="border-t border-white/[0.06] py-6 text-center text-xs text-neutral-600">© {new Date().getFullYear()} vyne</div>
    </footer>
  );
}
